import React, {useState} from "react";
import style from "./ContactForm.module.scss"
import InputField from "../../InputField/ui/InputField"
import {sendFormData} from "../../../axios/api"
import ContactImage from "../../../images/contactForm/frame_contacts.png"

const TextAreaField = ({placeHolder, value, onChange}: {
    placeHolder?: string,
    value?: string,
    onChange?: (value: string) => void
}) => {
    return <textarea className={style.textareaField} placeholder={placeHolder} value={value}
                     onChange={(e) => onChange && onChange(e.target.value)}/>
}

interface ContactForm {
    segment?: string;
    politic?: string;
    title?: string;
    subtitle?: string;
}

export default function ContactForm(props: ContactForm) {
    const title_success = 'Заявка успешно отправлена';
    const subtitle_success = 'Скоро с вами свяжется специалист';

    const [emailError, setEmailError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');

    const [formData, setFormData] = useState<{ [key: string]: string }>({text: ''})

    const getValue = (key: string): string => {
        return formData[key] || ''
    }

    const onChange = (value: string, key: string) => {
        setFormData(prevState => ({...prevState, [key]: value}))
    }

    const validatePhoneNumber = (value: string) => {
        if (!value) {
            setPhoneNumberError('*Обязательное поле');
            return false;
        }
        const regex = /(\+7|8)[- _]*\(?[- _]*(\d{3}[- _]*\)?([- _]*\d){7}|\d\d[- _]*\d\d[- _]*\)?([- _]*\d){6})/;
        if (!regex.test(value)) {
            setPhoneNumberError('Введите корректный номер телефона');
            return false;
        }
        setPhoneNumberError('');
        return true;
    };

    const validateEmail = (value: string) => {
        if (!value) {
            setEmailError('*Обязательное поле');
            return false;
        }
        const regex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/;
        if (!regex.test(value)) {
            setEmailError('Введите корректный email');
            return false;
        }
        setEmailError('');
        return true;
    };

    const [success, setSuccess] = useState<'Form' | 'End'>('Form');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const isEmailValid = validateEmail(formData["E-mail"]);
        const isPhoneNumberValid = validatePhoneNumber(formData["phoneNumber"]);

        if (isEmailValid && isPhoneNumberValid) {

            setSuccess('End')

            const currentDate = new Date();
            sendFormData({
                full_name: formData['fullName'],
                phone_number: formData['phoneNumber'],
                email: formData['E-mail'],
                comment: formData['comment'],
                send_date: currentDate.toISOString()
            }).catch(console.error);
        }
    };

    const Form = () => {
        return (
            <div className={style.contactForm}>
                <div className={style.title}>
                    <h3 className={style.mainTitle}>{props.title}</h3>
                    <div className={style.subTitle}>{props.subtitle}</div>
                </div>
                <div className={style.inputFieldContainer}>
                    <InputField placeHolder={"Фамилия Имя Отчество"} value={getValue('fullName')}
                                onChange={(v) => onChange(v, 'fullName')}/>
                    <InputField error={phoneNumberError} placeHolder={"+7"} value={getValue('phoneNumber')}
                                onChange={(v) => onChange(v, 'phoneNumber')}/>

                    <InputField error={emailError} placeHolder={"E-mail"} value={getValue('E-mail')}
                                onChange={(v) => onChange(v, 'E-mail')}/>

                    <TextAreaField placeHolder={"Комментарий"} value={getValue('comment')}
                                   onChange={(v) => onChange(v, 'comment')}/>

                    <div className={style.containerSendData}>
                        <button className={style.buttonSendData} onClick={handleSubmit}>
                            <div className={style.textContainer}>
                                <div className={style.text}>Отправить</div>
                            </div>
                        </button>
                        <div className={style.textSendPolitic}>{props.politic}</div>
                    </div>
                </div>
            </div>
        )
    }

    const End = () => {
        return (
            <div className={style.contactSendSuccess}>
                <div className={style.successTitle}>{title_success}</div>
                <div className={style.subTitle}>{subtitle_success}</div>
                <p className={style.successText}>Мы работаем исключительно в сегменте B2B, что обязывает нас придерживаться высочайших стандартов
                    деловой этики. Вся предоставляемая вами информация защищена и используется только в рамках нашего
                    сотрудничества. Для вашего спокойствия мы готовы заключить договор о неразглашении (NDA), который
                    обеспечит полную конфиденциальность данных</p>
            </div>
        )
    }

    return (
        <div id="container" className={style.container} style={{flexDirection: "row"}}>
            <div className={style.leftContainer}>
                {success === 'Form' ? Form() : End()}
            </div>

            <div className={style.imgContainer}>
                <img className={style.building} src={ContactImage} alt="Building"/>
            </div>
        </div>
    )
}
